document.addEventListener("DOMContentLoaded", () => {
  console.log("dom content load initiated");

  if (window.customerData && Array.isArray(window.customerData.customerTag)) {
    const tags = window.customerData.customerTag;
    console.log("tags value", tags);

    const isDisabledPage = window.location.pathname.includes("/pages/disable-user");

    if (tags.includes("disabled") || tags.includes("deleted")) {
      if (!isDisabledPage) {
        window.location.href = "/pages/disable-user";
      }

      if (isDisabledPage) {

        // removing tokens from local storage
          localStorage.removeItem("gbRefreshTokenExpiresIn");
          localStorage.removeItem("gbToken");
          localStorage.removeItem("gbTokenExpiresIn");
          localStorage.removeItem("gbRefreshToken");

          //logging out customer 
         const allCleared =
                  !localStorage.getItem("gbRefreshTokenExpiresIn") &&
                  !localStorage.getItem("gbToken") &&
                  !localStorage.getItem("gbTokenExpiresIn") &&
                  !localStorage.getItem("gbRefreshToken");
          
          console.log("all local storage clear response",allCleared);
          if (allCleared) {
            // Logging out customer after 5 seconds
            setTimeout(() => {
              window.location.href = "/account/logout";
            }, 5000);
          }
      }
    }
  }
});
